var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGitDiff = function SvgIconGitDiff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 6.375A3.625 3.625 0 1 1 6.625 9.86v2.899a3.52 3.52 0 0 0 1.029 2.48L9.5 17.087V15.75a1 1 0 1 1 2 0v3.75a1 1 0 0 1-1 1H6.75a1 1 0 1 1 0-2h1.336L6.24 16.654a5.52 5.52 0 0 1-1.615-3.893v-2.9A3.63 3.63 0 0 1 2 6.374M5.625 4.75a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25M12.5 4.5a1 1 0 0 1 1-1h3.75a1 1 0 1 1 0 2h-1.336l1.846 1.846a5.52 5.52 0 0 1 1.615 3.893v2.9a3.627 3.627 0 0 1-1 7.111 3.625 3.625 0 0 1-1-7.11v-2.898a3.52 3.52 0 0 0-1.03-2.482L14.5 6.914V8.25a1 1 0 1 1-2 0zM18.375 16a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25"
  }))));
};
export default SvgIconGitDiff;